/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagRemediationRequest extends models.TagsRemediation {
    getFixupPrototypeFunction() { return TagRemediationRequest.fixupPrototype; }

    static newInstance(model: Partial<TagRemediationRequest>): TagRemediationRequest {
        let obj = Object.assign(new TagRemediationRequest(), model);
        TagRemediationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagRemediationRequest>): TagRemediationRequest {
        if (!model) return null;
        return TagRemediationRequest.newInstance(<TagRemediationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagRemediationRequest) {
        if (!obj) return;

        models.TagRemediationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagRemediationRequest): boolean {
        if (models.TagsRemediation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagRemediationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * service_account_id
     */
    service_account_id: string;

}
